import { useCallback, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Eye, RefreshCw, BellOff, Bell, Eraser } from "lucide-react";
import API from "../apiBase";

const formatta = (iso) => {
  const d = new Date(iso);
  if (isNaN(d)) return iso;
  return d.toLocaleString("it-IT", {
    weekday: "long",
    day: "numeric",
    month: "long",
    hour: "2-digit",
    minute: "2-digit",
  });
};

/* Pagina riservata: quante volte è stata aperta la sorpresa */
export default function VisitePage() {
  const [dati, setDati] = useState(null);
  const [errore, setErrore] = useState(false);
  const [nospy, setNospy] = useState(
    () => localStorage.getItem("nospy") === "1"
  );

  const toggleNospy = () => {
    const v = !nospy;
    setNospy(v);
    if (v) localStorage.setItem("nospy", "1");
    else localStorage.removeItem("nospy");
  };

  const azzera = () => {
    if (
      !window.confirm(
        "Sicuro? Cancello tutte le visite e i traguardi registrati finora."
      )
    )
      return;
    fetch(`${API}/api/visite/azzera`, { method: "POST" })
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(() => carica())
      .catch(() => setErrore(true));
  };

  const carica = useCallback(() => {
    setErrore(false);
    fetch(`${API}/api/visite`)
      .then((r) => (r.ok ? r.json() : Promise.reject()))
      .then(setDati)
      .catch(() => setErrore(true));
  }, []);

  useEffect(() => {
    carica();
  }, [carica]);

  return (
    <main className="visite-page" data-testid="visite-page">
      <p className="visite-eyebrow">
        <Eye size={14} /> pagina riservata
      </p>
      <h1 className="visite-title">Chi ha visto le stelle</h1>

      {errore && (
        <p className="visite-errore" data-testid="visite-errore">
          Non riesco a leggere le visite. Riprova tra poco.
        </p>
      )}

      {dati && (
        <>
          <motion.div
            className="visite-totale-card"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7 }}
          >
            <span className="visite-totale" data-testid="visite-totale">
              {dati.totale}
            </span>
            <span className="visite-totale-label">
              {dati.totale === 1 ? "visita" : "visite"}
            </span>
          </motion.div>

          {dati.traguardi && dati.traguardi.length > 0 && (
            <motion.div
              className="visite-traguardo"
              data-testid="visite-traguardo"
              initial={{ opacity: 0, scale: 0.9 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.7, delay: 0.2 }}
            >
              <svg
                className="visite-traguardo-icon"
                viewBox="0 0 24 24"
                aria-hidden="true"
              >
                <path d="M12 1.8 L15 8.3 L22 9.1 L16.8 13.9 L18.4 20.8 L12 17.1 L5.6 20.8 L7.2 13.9 L2 9.1 L9 8.3 Z" />
              </svg>
              <p className="visite-traguardo-title">Ha acceso tutte le stelle</p>
              <p className="visite-traguardo-sub" data-testid="visite-traguardo-sub">
                {dati.traguardi.length === 1
                  ? "1 volta"
                  : `${dati.traguardi.length} volte`}{" "}
                — ultima: {formatta(dati.traguardi[0].at)}
              </p>
            </motion.div>
          )}

          {dati.visite.length > 0 && (
            <p className="visite-ultima" data-testid="visite-ultima">
              Ultima visita: {formatta(dati.visite[0].at)}
            </p>
          )}

          <ul className="visite-lista" data-testid="visite-lista">
            {dati.visite.map((v, i) => (
              <li key={i} className="visite-item">
                <span className="visite-item-star">✦</span>
                {formatta(v.at)}
                {v.disp && <span className="visite-item-disp"> · {v.disp}</span>}
              </li>
            ))}
          </ul>
        </>
      )}

      <button
        className="visite-refresh"
        onClick={carica}
        data-testid="visite-refresh"
        aria-label="Aggiorna il conteggio"
      >
        <RefreshCw size={15} /> aggiorna
      </button>

      <button
        className={`visite-nospy${nospy ? " visite-nospy--on" : ""}`}
        onClick={toggleNospy}
        data-testid="visite-nospy-toggle"
        aria-pressed={nospy}
      >
        {nospy ? <BellOff size={14} /> : <Bell size={14} />}
        {nospy
          ? "questo dispositivo non fa scattare notifiche"
          : "silenzia le notifiche su questo dispositivo"}
      </button>

      <button
        className="visite-azzera"
        onClick={azzera}
        data-testid="visite-azzera-btn"
        aria-label="Azzera tutti i conteggi"
      >
        <Eraser size={14} /> azzera i conteggi
      </button>
    </main>
  );
}
